export default "__VITE_ASSET__DS7TM0tL__"